import { useState } from 'react';
import { createClubInvite, type ClubMemberRole } from '../../../api';
import { getApiErrorMessage } from '../../../utils/apiError';
import { copyToClipboard } from '../../../utils/copyToClipboard';

export function useMemberInvite({
  showError,
  showSuccess,
}: {
  showError: (message: string) => void;
  showSuccess: (message: string) => void;
}) {
  const [inviteLink, setInviteLink] = useState<string | null>(null);
  const [inviteRole, setInviteRole] = useState<ClubMemberRole>('pilot');

  const handleInvite = async () => {
    try {
      const res = await createClubInvite({ role: inviteRole, days: 14 });
      const link = `${window.location.origin}/invite/${res.data.token}`;
      setInviteLink(link);
      if (await copyToClipboard(link)) {
        showSuccess('Ссылка скопирована');
      }
    } catch (error) {
      showError(getApiErrorMessage(error, 'Не удалось создать приглашение'));
    }
  };

  const copyInviteLink = async () => {
    if (!inviteLink) return;
    if (await copyToClipboard(inviteLink)) {
      showSuccess('Ссылка скопирована');
      return;
    }
    showError('Не удалось скопировать — выделите ссылку вручную');
  };

  return {
    inviteLink,
    setInviteLink,
    inviteRole,
    setInviteRole,
    handleInvite,
    copyInviteLink,
  };
}
